import { SITE } from "../config/site";
import { GOALS, reachGoal } from "./metrika";

// Both store links point to the Nasiyah **Merchant** (Business) app. This picks the
// right one for the visitor's device so the single "Bepul boshlash" CTA deep-links
// straight to the correct store. Client-side only — reads `navigator`.

export type Platform = "ios" | "android" | "desktop";

/** Best-effort platform detection (client-only; returns "desktop" during SSG). */
export function detectPlatform(): Platform {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  const isIOS =
    /iphone|ipad|ipod/i.test(ua) ||
    // iPadOS 13+ reports as desktop Safari ("MacIntel"); touch points disambiguate it.
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return isIOS ? "ios" : "desktop";
}

/** Best-effort store URL: Android → Google Play, iOS/iPadOS → App Store, desktop → App Store. */
export function merchantStoreUrl(): string {
  // desktop / unknown — App Store page still showcases the app
  return detectPlatform() === "android" ? SITE.stores.googlePlay : SITE.stores.appStore;
}

/** Open the device-correct merchant store in a new tab. Call inside a click handler (user gesture). */
export function openMerchantStore(): void {
  if (typeof window === "undefined") return;
  reachGoal(GOALS.startApp); // count the primary "Bepul boshlash" conversion
  window.open(merchantStoreUrl(), "_blank", "noopener,noreferrer");
}
